import jwtDecode from 'jwt-decode';
import moment from 'moment';
import React, { ReactNode } from 'react';
import { LoadingSpinnerIcon } from '../../../Icons/LoadingSpinnerIcon';
import { AnadoluLogo } from '../../../assets/images/anadolu-logo';
import { EvolveLogo } from '../../../assets/images/evolve-logo';
import {
  buildPortalLoginUrl,
  getLocalStorageOrDefault,
  isAnadoluPortalContext,
} from '../../../utils';

interface AuthorizedProps {
  loading?: boolean;
  children: ReactNode;
}

export const LoadingAuth = () => {
  const showAnadoluLogo =
    typeof window !== 'undefined' && isAnadoluPortalContext();

  return (
    <div className='authorized' role='status'>
      <LoadingSpinnerIcon large />
      {showAnadoluLogo ? <AnadoluLogo /> : <EvolveLogo />}
    </div>
  );
};

// ! this cannot exist in utils. it won't work
const isDevelopment = process.env.NODE_ENV === 'development';

export const Authorized = ({ children, loading }: AuthorizedProps) => {
  if (!loading && typeof window !== 'undefined') {
    const token = getLocalStorageOrDefault('access_token');

    let expiredToken = false;
    if (token) {
      try {
        const tokenInfo = jwtDecode(token || '') as { exp: number };
        expiredToken = moment(tokenInfo?.exp * 1000) < moment();
      } catch (error) {
        // token should not be wrong
        expiredToken = true;
      }
    }

    if (!isDevelopment && (!token || expiredToken)) {
      window.location.href = buildPortalLoginUrl(window.location.toString());
    }
    return <>{children}</>;
  } else {
    return <LoadingAuth />;
  }
};
